import Component from '../lib/Component'

export default class MenuLink extends Component {

}

